import { z } from "zod";
import { optionalAddressSchema } from "./address";

/** Servicos oferecidos pela radiologia. */
export const RADIOLOGY_SERVICES = [
  "TOMOGRAFIA",
  "CEFALOMETRIA",
  "PANORAMICA",
  "PERIAPICAL",
  "ESCANEAMENTO",
] as const;

export const radiologyServiceSchema = z.enum(RADIOLOGY_SERVICES);
export type RadiologyService = z.infer<typeof radiologyServiceSchema>;

export const RADIOLOGY_SERVICE_LABELS: Record<RadiologyService, string> = {
  TOMOGRAFIA: "Tomografia",
  CEFALOMETRIA: "Cefalometria",
  PANORAMICA: "Panoramica",
  PERIAPICAL: "Periapical",
  ESCANEAMENTO: "Escaneamento",
};

export const MAX_LOGO_DATA_URL_LENGTH = 700_000;

export const updateRadiologyProfileSchema = z.object({
  services: z.array(radiologyServiceSchema).default([]),
  logoUrl: z
    .string()
    .startsWith("data:image/")
    .max(MAX_LOGO_DATA_URL_LENGTH, "Imagem muito grande (max ~500KB)")
    .nullable()
    .optional(),
  addressSame: z.boolean().default(true),
  address: optionalAddressSchema.optional(),
});

export type UpdateRadiologyProfileInput = z.infer<typeof updateRadiologyProfileSchema>;
